'use client';

import React from 'react';

import type { AriaButtonProps } from '@react-aria/button';
import { mergeRefs } from '@react-aria/utils';
import { Button } from 'react-aria-components';
import type { ClassValue } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

export type UnstyledButtonProps = AriaButtonProps & {
  className?: ClassValue;
};

export const UnstyledButton = React.forwardRef<
  HTMLButtonElement,
  UnstyledButtonProps
>(({ className, children, ...props }, forwardedRef) => {
  const ref = React.useRef(null);

  return (
    <Button
      isDisabled={props.isDisabled}
      className={cn(
        'text-body-2 m-0 inline-flex cursor-pointer bg-transparent p-0 outline-none',
        className,
      )}
      ref={mergeRefs(ref, forwardedRef)}
      {...props}
    >
      {children}
    </Button>
  );
});

UnstyledButton.displayName = 'UnstyledButton';
